import React from "react";

const SoftwareDevelopmentHeroSection = () => {
  return (
    <section className="py-20 flex items-center justify-center bg-gradient-to-br from-indigo-600 via-blue-900 to-slate-900 text-white relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-20 pointer-events-none">
        <div className="absolute -top-40 -left-40 w-96 h-96 bg-purple-500 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 -right-40 w-96 h-96 bg-blue-500 rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-6 z-10 text-center">
        <span className="inline-block py-1 px-3 rounded-full bg-blue-800/30 border border-indigo-400/30 text-indigo-200 text-sm font-semibold tracking-wider mb-6 animate-pulse">
          NEXT GENERATION SOFTWARE SOLUTIONS
        </span>
        <h1 className="text-5xl md:text-7xl font-extrabold tracking-tight mb-6 leading-tight">
          Innovating Your <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-400">
            Digital Future
          </span>
        </h1>

        <p className="text-lg md:text-xl text-gray-300 mb-10 max-w-2xl mx-auto leading-relaxed">
          We engineer high-performance software, scalable web platforms, and
          secure mobile applications that drive your business growth in the
          modern era.
        </p>

        {/*  (Call to Action) */}
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <a
            href="/services"
            className="px-8 py-4 cursor-pointer bg-transparent border border-gray-500 hover:border-white text-gray-300 hover:text-white font-semibold rounded-lg transition-all duration-300"
          >
            View Our Services
          </a>
        </div>
      </div>
    </section>
  );
};

export default SoftwareDevelopmentHeroSection;
